/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import{useLexicalSubscription as i}from"@lexical/react/useLexicalSubscription";function e(i){return{initialValueFn:()=>i.isEditable(),subscribe:e=>i.registerEditableListener(e)}}function r(){return i(e)}export{r as useLexicalEditable};
